export default function () {
  this.doStartCompany()
}



// WEBPACK FOOTER //
// ./src/app/professional/company/prices/resources/mounted.js